export const ChartLineType = {
  SOLID: [0, 0],
  DOTTED: [2, 1],
  DASHED: [8, 4],
  MIX: [12, 8]
};
